import api from './api';

const ledgerService = {
  // Admin: Dashboard summary (account balances, totals, last sequence)
  getDashboard: () =>
    api.get('/admin/ledger/dashboard'),

  // Admin: Paginated ledger entries with filters
  getEntries: (params) =>
    api.get('/admin/ledger/entries', { params }),
  // params: { page, limit, event_type, account_type, entry_type,
  //           user_id, astrologer_id, consultation_id, date_from, date_to }

  // Admin: Journal detail with all legs
  getJournal: (journalId) =>
    api.get(`/admin/ledger/journals/${journalId}`),

  // Admin: Ledger-derived revenue vs billing_events comparison
  getRevenue: (params) =>
    api.get('/admin/ledger/revenue', { params }),

  // Admin: Chain integrity verification
  verifyChain: (fromSequence) =>
    api.post('/admin/ledger/verify-chain', null, {
      params: fromSequence != null ? { from_sequence: fromSequence } : {}
    }),

  // Admin: Reconciliation report for a date (YYYY-MM-DD)
  getReconciliation: (date) =>
    api.get(`/admin/ledger/reconciliation/${date}`),

  // Admin: Reversal workflow
  createReversal: (data) =>
    api.post('/admin/ledger/reversals', data),
  // data: { original_entry_uuid, reason }

  approveReversal: (reversalId) =>
    api.post(`/admin/ledger/reversals/${reversalId}/approve`),

  getReversals: () =>
    api.get('/admin/ledger/reversals'),

  // Admin: CSV export (returns blob)
  exportCSV: (params) =>
    api.get('/admin/ledger/export', { params, responseType: 'blob' }),

  // Astrologer: Earnings from ledger perspective
  getAstrologerEarnings: (params) =>
    api.get('/astrologer/ledger/earnings', { params }),
};

export default ledgerService;
